export default {"src":"/_next/static/media/fidibo.de94cb89.svg","height":24,"width":77,"blurWidth":0,"blurHeight":0};